export const ALLOWED_IMAGE_TYPES = new Set([
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "application/pdf",
    "application/postscript",
]);

export function isAllowedImageType(mimeType) {
    return ALLOWED_IMAGE_TYPES.has(mimeType);
}

export function dispatchFigureModalPasteEvent(imageData) {
    window.dispatchEvent(
        new CustomEvent("figure-modal:paste-image", {
            detail: imageData,
        }),
    );
}

export async function findImageInClipboard() {
    try {
        const clipboardItems = await navigator.clipboard.read();

        for (const item of clipboardItems) {
            for (const type of item.types) {
                if (isAllowedImageType(type)) {
                    const blob = await item.getType(type);
                    return new File([blob], `image.${type.split("/")[1]}`, {
                        type,
                    });
                }
            }
        }
    } catch (_error) {
        return null;
    }

    return null;
}

export async function handleImagePaste() {
    const imageFile = await findImageInClipboard();
    if (imageFile) {
        dispatchFigureModalPasteEvent({
            name: imageFile.name,
            type: imageFile.type,
            data: imageFile,
        });
        return true;
    }
    return false;
}
